// extracted by mini-css-extract-plugin
export default {"container":"NavbarHeader_container__py50K"};